import { Reveal } from "../components/Reveal";
import { useSiteImages } from "../context/SiteImagesContext";
import { API } from "../lib/api";

const ITEMS = [
  {
    key: "gallery:colores",
    title: "Todos los colores",
    caption: "Verde, azul, amarillo, rosa, rojo y blanco. Elige la que te acompañe.",
    span: "sm:col-span-6",
    aspect: "aspect-[16/10]",
    fit: "object-cover",
  },
  {
    key: "gallery:indice",
    title: "Índice personalizado",
    caption: "Las 29 especialidades ordenadas y un separador ilustrado para cada una.",
    span: "sm:col-span-6",
    aspect: "aspect-[16/10]",
    fit: "object-contain",
  },
  {
    key: "gallery:carpeta",
    title: "Portada Carpeta Médica",
    caption: "Árbol de la vida con órganos en acuarela: nuestro diseño insignia.",
    span: "sm:col-span-3",
    aspect: "aspect-[4/5]",
    fit: "object-cover",
  },
  {
    key: "gallery:vitae",
    title: "Portada VITAE",
    caption: "Diseño limpio y elegante con nuestro sello.",
    span: "sm:col-span-3",
    aspect: "aspect-[4/5]",
    fit: "object-cover",
  },
];

// Optional extra photos: they appear in the gallery only when Ana uploads
// them from the admin panel (slots "gallery:extra1" / "gallery:extra2").
const EXTRA_ITEMS = [
  {
    key: "gallery:extra1",
    title: "Detalles que enamoran",
    caption: "Cada carpeta se prepara a mano, con mimo, una a una.",
    span: "sm:col-span-3",
    aspect: "aspect-[4/5]",
    fit: "object-cover",
  },
  {
    key: "gallery:extra2",
    title: "Lista para tu día a día",
    caption: "De la consulta a casa: todo tu historial en su sitio.",
    span: "sm:col-span-3",
    aspect: "aspect-[4/5]",
    fit: "object-cover",
  },
];

export default function InteriorGaleria() {
  const { resolve, uploaded } = useSiteImages();
  const visibleItems = [...ITEMS, ...EXTRA_ITEMS.filter((it) => uploaded.includes(it.key))];

  return (
    <section
      id="interior"
      data-testid="interior-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl mb-14">
          <p className="overline mb-6">
            <span className="text-[#D7C6A3]">04</span> &nbsp;/&nbsp; Por dentro
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-[#2D3732] leading-tight">
            Así es tu VITAE por dentro.
          </h2>
          <p className="text-[#4A554E] mt-5 max-w-xl leading-relaxed font-light">
            Cada carpeta es única: portada personalizada, índice de especialidades y
            separadores ilustrados a mano por Ana.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-6 gap-5">
          {visibleItems.map((it, i) => (
            <Reveal
              key={it.key}
              delay={i * 0.08}
              className={`${it.span} rounded-[2rem] overflow-hidden border border-[#EBEBEB] bg-[#FAF9F6] group`}
            >
              <figure className="relative">
                <div className={`${it.aspect} overflow-hidden bg-[#F6F1E7]`}>
                  <img
                    src={resolve(it.key, `${API}/images/${it.key}`)}
                    alt={it.title}
                    className={`w-full h-full ${it.fit} group-hover:scale-[1.03] transition-transform duration-1000`}
                    data-testid={`interior-img-${it.key.split(":")[1]}`}
                  />
                </div>
                <figcaption className="p-6 bg-white">
                  <p className="font-display text-xl text-[#2D3732] leading-tight">
                    {it.title}
                  </p>
                  <p className="text-sm text-[#6B705C] mt-1 font-light leading-relaxed">
                    {it.caption}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
